import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignmentService } from './assignment.service';

@NgModule({
  imports: [CommonModule],
  providers: [AssignmentService],
})
export class AssignmentModule {}
